// src/pages/Contact.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Contact() {
  const [form, setForm] = useState({ name:"", email:"", phone:"", subject:"", message:"" });
  const [sent, setSent] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const S = {fontFamily:"'DM Sans',sans-serif"};
  const PJS = {fontFamily:"'Plus Jakarta Sans',sans-serif"};

  return (
    <>
      <Navbar/>
      <div style={{background:"#1565C0",padding:"40px 20px 48px"}}>
        <div style={{maxWidth:800,margin:"0 auto",textAlign:"center"}}>
          <div style={{display:"flex",gap:6,alignItems:"center",justifyContent:"center",marginBottom:14,fontSize:13,flexWrap:"wrap"}}>
            <Link to="/" style={{color:"rgba(255,255,255,.7)"}}>Home</Link>
            <span style={{color:"rgba(255,255,255,.3)"}}>›</span>
            <span style={{color:"#fff",fontWeight:600}}>Contact Us</span>
          </div>
          <h1 style={{fontSize:"clamp(24px,4vw,36px)",fontWeight:900,color:"#fff",margin:"0 0 10px",...PJS}}>Contact Us</h1>
          <p style={{color:"rgba(255,255,255,.82)",fontSize:16,...S}}>We're here to help with any questions about your holiday</p>
        </div>
      </div>
      <div style={{maxWidth:1100,margin:"0 auto",padding:"40px 20px 100px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:32}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:800,marginBottom:20,color:"#1a1a1a",...PJS}}>Get in touch</h2>
          {sent ? (
            <div style={{background:"#e8f5e9",border:"1px solid #a5d6a7",borderRadius:10,padding:28,textAlign:"center"}}>
              <div style={{fontSize:36,marginBottom:12}}>✓</div>
              <h3 style={{fontWeight:800,marginBottom:8,...PJS}}>Message sent!</h3>
              <p style={{color:"#555",...S}}>We'll get back to you within 2 hours during business hours.</p>
            </div>
          ) : (
            <form onSubmit={e=>{e.preventDefault();setSent(true);}}>
              {[["Full Name","name","text",true],["Email","email","email",true],["Phone","phone","tel",false],["Subject","subject","text",true]].map(([l,k,t,r])=>(
                <div key={k} style={{display:"flex",flexDirection:"column",gap:5,marginBottom:14}}>
                  <label style={{fontSize:13,fontWeight:700,color:"#333",...S}}>{l}{r&&<span style={{color:"#e53935"}}> *</span>}</label>
                  <input type={t} value={form[k]} onChange={e=>set(k,e.target.value)} required={r}
                    style={{padding:"11px 12px",border:"1.5px solid #ddd",borderRadius:7,fontSize:15,...S,fontFamily:"inherit"}}/>
                </div>
              ))}
              <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:18}}>
                <label style={{fontSize:13,fontWeight:700,color:"#333",...S}}>Message<span style={{color:"#e53935"}}> *</span></label>
                <textarea value={form.message} onChange={e=>set("message",e.target.value)} rows={5} required
                  style={{padding:"11px 12px",border:"1.5px solid #ddd",borderRadius:7,fontSize:15,...S,fontFamily:"inherit",resize:"vertical"}}/>
              </div>
              <button type="submit" style={{width:"100%",padding:"14px",background:"#2E7D32",color:"#fff",border:"none",borderRadius:8,fontSize:16,fontWeight:800,cursor:"pointer",...PJS}}>
                Send message
              </button>
            </form>
          )}
        </div>
        <div>
          <h2 style={{fontSize:20,fontWeight:800,marginBottom:20,color:"#1a1a1a",...PJS}}>Our details</h2>
          {[
            {h:"Phone",v:"020 3019 0055",href:"tel:02030190055"},
            {h:"WhatsApp",v:"+44 7487 672075",href:"https://wa.me/447487672075"},
            {h:"Email",v:"support@broadwayholidays.co.uk",href:"mailto:support@broadwayholidays.co.uk"},
            {h:"Address",v:"Brayford Square, E1 0SG, London"},
            {h:"Hours",v:"Mon–Fri 9am–7pm · Sat–Sun 10am–5pm"},
          ].map((item,i)=>(
            <div key={i} style={{background:"#fff",border:"1px solid #e5e5e5",borderRadius:9,padding:"14px 18px",marginBottom:10}}>
              <div style={{fontSize:11,fontWeight:800,color:"#888",textTransform:"uppercase",letterSpacing:".07em",marginBottom:4,...S}}>{item.h}</div>
              {item.href?<a href={item.href} target={item.href.startsWith("http")?"_blank":undefined} rel="noreferrer" style={{fontSize:15,fontWeight:600,color:"#1565C0",textDecoration:"none",...S}}>{item.v}</a>:<div style={{fontSize:15,fontWeight:600,color:"#1a1a1a",...S}}>{item.v}</div>}
            </div>
          ))}
        </div>
      </div>
      <Footer/>
      <style>{"@media(max-width:700px){div[style*='gridTemplateColumns: 1fr 1fr']{grid-template-columns:1fr!important}}"}</style>
    </>
  );
}